import { createContext, useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../api/client';
import { useAuth } from './AuthContext';

const FavoritesContext = createContext();
export const useFavorites = () => useContext(FavoritesContext);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  // Para invitados usamos localStorage; logueados sincroniza con el backend.
  const [ids, setIds] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('msf_favs')) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('msf_favs', JSON.stringify(ids));
  }, [ids]);

  useEffect(() => {
    if (user?.favorites) {
      setIds(user.favorites.map((f) => (typeof f === 'string' ? f : f._id)));
    }
  }, [user]);

  const isFavorite = (id) => ids.includes(id);

  const toggleFavorite = async (product) => {
    const id = product._id;
    const wasFav = isFavorite(id);
    setIds((prev) => (wasFav ? prev.filter((x) => x !== id) : [...prev, id]));
    toast.success(wasFav ? 'Quitado de favoritos' : 'Agregado a favoritos ♥');

    if (user) {
      try {
        await api.post(`/account/favorites/${id}`);
      } catch {
        /* no-op en demo */
      }
    }
  };

  return (
    <FavoritesContext.Provider value={{ ids, isFavorite, toggleFavorite, count: ids.length }}>
      {children}
    </FavoritesContext.Provider>
  );
}
